import { DownloadButtonClickEventProductObject, GenericButtonClickEventProductObject, TrialButtonClickEventProductObject } from "./typeDefinitions";

export class ButtonClickEvent {
  event   : 'trial downloaded' | 'product downloaded' | 'file downloaded' | 'click' | string;
  asset?  : string;
  product?: GenericButtonClickEventProductObject | TrialButtonClickEventProductObject | DownloadButtonClickEventProductObject;

  constructor(clickEvent: 'trial downloaded', params: { productId: string } );
  constructor(clickEvent: 'product downloaded', params: { productId: string });
  constructor(clickEvent: 'file downloaded' | 'click', params: { asset: string });
  constructor(clickEvent: string, params: { productId: string });
  constructor(clickEvent: string, params: { productId: string, asset: string }) {
    this.event = clickEvent;
    const { productId, asset } = params;

    if (clickEvent === 'trial downloaded') {
      this.product = { trial: [{ ID: productId }] };
    } else if (clickEvent === 'product downloaded') {
      this.product = { download: [{ ID: productId }] };
    } else if (['file downloaded', 'click'].includes(clickEvent)) {
      this.asset = asset;
    } else {
      this.product = { [clickEvent]: [{ ID: productId }] };
    }

    if (!this.asset) delete this.asset;
    if (!this.product) delete this.product;
  }
}